// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__U84sn","spin":"loader_spin__y8SnJ"};